(() => {
  const VERSION = '2026-08-20.1';
  if (window.PBLogoUSBSavedV1?.version === VERSION) return;

  const configEl = document.querySelector('[data-pb-logo-v3-config]');
  if (!configEl) return;

  let CONFIG = {};
  try { CONFIG = JSON.parse(configEl.textContent || '{}'); }
  catch (error) { console.warn('PB saved USB logo config unavailable', error); return; }

  const normalize = value => String(value || '').trim().toLowerCase();
  const rawDies = CONFIG.customerDies;
  const dies = (Array.isArray(rawDies) ? rawDies : Array.isArray(rawDies?.dies) ? rawDies.dies : [])
    .filter(die => normalize(die?.status) === 'active')
    .filter(die => die?.artwork_url || die?.preview_url);

  if (!CONFIG.loggedIn || !dies.length) {
    window.PBLogoUSBSavedV1 = { version: VERSION, active: false, refresh: () => {} };
    return;
  }

  const PANEL_SELECTOR = '[data-pb-logo-v3="usb"]';
  const q = (root, selector) => root?.querySelector(selector) || null;
  const qa = (root, selector) => root ? [...root.querySelectorAll(selector)] : [];
  const selectedByPanel = new WeakMap();
  const busyByPanel = new WeakMap();

  const safeName = value => String(value || 'saved-logo')
    .trim()
    .replace(/[^a-z0-9._-]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'saved-logo';

  const artworkUrl = die => String(die?.artwork_url || die?.preview_url || '');

  const extensionFor = (url, mime = '') => {
    try {
      const path = new URL(url, window.location.origin).pathname.toLowerCase();
      const match = path.match(/\.(svg|png|pdf)$/i);
      if (match) return match[1].toLowerCase();
    } catch {}
    if (/svg/i.test(mime)) return 'svg';
    if (/png/i.test(mime)) return 'png';
    if (/pdf/i.test(mime)) return 'pdf';
    return '';
  };

  const fetchAsFile = async die => {
    const url = artworkUrl(die);
    if (!url) throw new Error('This saved logo has no artwork file attached.');
    const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
    if (!response.ok) throw new Error(`Saved artwork could not be loaded (${response.status}).`);
    const blob = await response.blob();
    const ext = extensionFor(url, blob.type);
    if (!ext) throw new Error('This saved logo file type cannot be reused on a USB. Please upload SVG, PDF or PNG artwork.');
    return new File([blob], `${safeName(die.name || die.label)}.${ext}`, {
      type: blob.type || (ext === 'svg' ? 'image/svg+xml' : ext === 'png' ? 'image/png' : 'application/pdf'),
      lastModified: Date.now()
    });
  };

  const setInputFile = (input, file) => {
    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const injectStyles = () => {
    if (document.getElementById('pb-logo-usb-saved-v1-style')) return;
    const style = document.createElement('style');
    style.id = 'pb-logo-usb-saved-v1-style';
    style.textContent = `
      .pb-logo-usb-saved-v1{margin:.9rem 0 1.1rem}
      .pb-logo-usb-saved-v1__title{margin:0 0 .45rem;font-size:1.22rem;font-weight:700;letter-spacing:.045em;text-transform:uppercase;opacity:.67}
      .pb-logo-usb-saved-v1__sources{display:grid;gap:.7rem}
      .pb-logo-usb-saved-v1__source{width:100%;display:grid;grid-template-columns:58px minmax(0,1fr) auto;gap:.85rem;align-items:center;padding:.75rem .9rem;border:1px solid rgba(var(--color-foreground),.18);border-radius:7px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit;text-align:left;cursor:pointer}
      .pb-logo-usb-saved-v1__source:hover{border-color:rgba(var(--color-foreground),.4)}
      .pb-logo-usb-saved-v1__source.is-active{outline:2px solid rgb(var(--color-foreground));outline-offset:-2px}
      .pb-logo-usb-saved-v1__thumb{display:flex;align-items:center;justify-content:center;width:58px;height:48px;padding:.3rem;overflow:hidden;border:1px solid rgba(var(--color-foreground),.1);border-radius:5px;background:#fff}
      .pb-logo-usb-saved-v1__thumb img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain}
      .pb-logo-usb-saved-v1__copy{min-width:0}.pb-logo-usb-saved-v1__copy strong{display:block}.pb-logo-usb-saved-v1__copy small{display:block;margin-top:.2rem;opacity:.7;line-height:1.3}
      .pb-logo-usb-saved-v1__badge{font-size:1.08rem;font-weight:650;white-space:nowrap;opacity:.75}
      .pb-logo-usb-saved-v1__status{margin:.7rem 0 0;padding:.75rem .9rem;border-radius:6px;background:rgba(var(--color-foreground),.045);font-size:1.18rem;line-height:1.4}
      .pb-logo-usb-saved-v1__status.is-error{background:#fff4f1;color:#70281f}
      @media(max-width:549px){.pb-logo-usb-saved-v1__source{grid-template-columns:50px minmax(0,1fr)}.pb-logo-usb-saved-v1__thumb{width:50px;height:43px}.pb-logo-usb-saved-v1__badge{grid-column:2;justify-self:start}}
    `;
    document.head.appendChild(style);
  };

  const clearSavedState = panel => {
    selectedByPanel.delete(panel);
    qa(panel, '[data-pb-usb-saved-die]').forEach(button => button.classList.remove('is-active'));
    const status = q(panel, '[data-pb-usb-saved-status]');
    if (status) {
      status.textContent = '';
      status.hidden = true;
      status.classList.remove('is-error');
    }
  };

  const selectSaved = async (panel, button, die) => {
    if (busyByPanel.get(panel)) return;
    const input = q(panel, '[data-pb-logo-v3-file]');
    if (!input) return;

    busyByPanel.set(panel, true);
    qa(panel, '[data-pb-usb-saved-die]').forEach(item => item.classList.toggle('is-active', item === button));
    const status = q(panel, '[data-pb-usb-saved-status]');
    if (status) {
      status.hidden = false;
      status.classList.remove('is-error');
      status.textContent = `Loading ${die.name || die.label || 'saved logo'}…`;
    }

    try {
      const file = await fetchAsFile(die);
      selectedByPanel.set(panel, { die, fileName: file.name });
      setInputFile(input, file);
      if (status) status.textContent = `Using saved logo: ${die.name || die.label || 'Saved logo'}. You can choose another saved logo or upload different artwork below.`;
    } catch (error) {
      selectedByPanel.delete(panel);
      button.classList.remove('is-active');
      if (status) {
        status.hidden = false;
        status.classList.add('is-error');
        status.textContent = error?.message || 'This saved logo could not be loaded. Please upload the artwork below.';
      }
    } finally {
      busyByPanel.delete(panel);
    }
  };

  const sourceButton = (panel, die) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pb-logo-usb-saved-v1__source';
    button.dataset.pbUsbSavedDie = String(die.id || die.die_id || die.name || 'saved');

    const thumb = document.createElement('span');
    thumb.className = 'pb-logo-usb-saved-v1__thumb';
    const img = document.createElement('img');
    img.src = artworkUrl(die);
    img.alt = die.name ? `${die.name} logo` : 'Saved logo';
    img.loading = 'lazy';
    thumb.appendChild(img);

    const copy = document.createElement('span');
    copy.className = 'pb-logo-usb-saved-v1__copy';
    const name = document.createElement('strong');
    name.textContent = die.name || die.label || 'Saved logo';
    const detail = document.createElement('small');
    detail.textContent = 'Saved to your account — ready to engrave';
    copy.append(name, detail);

    const badge = document.createElement('span');
    badge.className = 'pb-logo-usb-saved-v1__badge';
    badge.textContent = 'Saved';

    button.append(thumb, copy, badge);
    button.addEventListener('click', () => selectSaved(panel, button, die));
    return button;
  };

  const enhancePanel = panel => {
    if (!panel || panel.hidden || q(panel, '[data-pb-usb-saved-library]')) return;
    const fileInput = q(panel, '[data-pb-logo-v3-file]');
    const fields = q(panel, '[data-pb-logo-v3-fields]');
    if (!fileInput || !fields) return;

    const heading = q(panel, ':scope > h4');
    const intro = q(panel, ':scope > p');
    if (heading) heading.textContent = 'Which logo would you like to engrave?';
    if (intro) intro.textContent = 'Choose a saved logo from your account or upload new artwork for this USB.';

    const library = document.createElement('div');
    library.className = 'pb-logo-usb-saved-v1';
    library.dataset.pbUsbSavedLibrary = '';

    const title = document.createElement('div');
    title.className = 'pb-logo-usb-saved-v1__title';
    title.textContent = 'Saved logos';
    const sources = document.createElement('div');
    sources.className = 'pb-logo-usb-saved-v1__sources';
    dies.forEach(die => sources.appendChild(sourceButton(panel, die)));

    const status = document.createElement('div');
    status.className = 'pb-logo-usb-saved-v1__status';
    status.dataset.pbUsbSavedStatus = '';
    status.hidden = true;

    library.append(title, sources, status);
    fields.before(library);

    const fieldLabel = q(fields, '.pb-logo-v3__field > label');
    if (fieldLabel) fieldLabel.textContent = 'Or upload new logo artwork *';

    fileInput.addEventListener('change', event => {
      const selected = selectedByPanel.get(panel);
      if (!selected) return;
      const current = fileInput.files?.[0];
      if (!current || current.name === selected.fileName) return;
      if (event.isTrusted || current.name !== selected.fileName) clearSavedState(panel);
    });
  };

  const scan = () => qa(document, PANEL_SELECTOR).forEach(enhancePanel);

  injectStyles();
  scan();
  new MutationObserver(() => requestAnimationFrame(scan)).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['hidden']
  });

  window.PBLogoUSBSavedV1 = { version: VERSION, active: true, refresh: scan };
})();
